import React, {useEffect, useState} from 'react'
import { CasoGeneralComponent } from 'reccol-caso-general'
import EncargadoCompania from '.'
import { useLocation } from 'react-router-dom'
import { obtenerDatosLlaves } from '../../store/actions/encargado-compania-action'
import { useDispatch, useSelector } from 'react-redux'
import AtenderSolicitud from './atenderSolicitud'
import { Card, Container } from 'react-bootstrap'

const AntederSolicitudDescuento = () => {

    const {state}=useLocation()
    const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :30
    const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
    const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
    const dispatch = useDispatch()
   
    useEffect(()=>{       
        dispatch(obtenerDatosLlaves({idCaso:idCasoLocation, idImplicado:idImplicado,idOrgCaso:idOrganizacionCaso}))
    },[dispatch])  
    
    return (
        <div> 
            
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{`Atiende Solicitud Descuento Recobro - Caso ${idCasoLocation}`}</Card.Header>
                    <Card.Body>
                        <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} /> 
                    </Card.Body>
                </Card>
            </Container> 
            <AtenderSolicitud />
        </div>
    )
}
export default AntederSolicitudDescuento
